import { selectCurrentHotelId } from 'accessors'
import BookingListDialog from 'features/Analytics/BookingListDialog'
import { provideEndDate } from 'features/Analytics/provideEndDate'
import BookingHistory from 'features/BookingDetails/BookingHistory'
import BookingDetailsDialog from 'features/BookingDetailsDialog'
import useFirstRender from 'hooks/useFirstRender'
import usePlausible from 'hooks/usePlausible'
import download from 'js-file-download'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import performanceReportsApi from 'services/api/performanceReports'

const CampaignConversionResults = ({
  category,
  fromDate,
  toDate,
  kind,
  onClose,
  segment,
  showWholeGroup,
  searchKey,
  selectedParentChainFilter
}) => {
  const parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)
  const [isLoading, setIsLoading] = useState(true)
  const [isErred, setIsErred] = useState()
  const [stats, setStats] = useState(null)
  const [downloadCSVLoading, setDownloadCSVLoading] = useState(false)

  const [pageIndex, setPageIndex] = useState(1)

  const [totalSize, setTotalSize] = useState(1)

  let pageSize = 20

  const [activeSubscriberId, setActiveSubscriberId] = useState()

  const [activeBookingId, setActiveBookingId] = useState()

  const [bookings, setBookings] = useState([])

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)

  useEffect(() => {
    setIsLoading(true)

    performanceReportsApi
      .conversionsBreakdown({
        campaign: segment,
        onlyDirectBooking: searchKey,
        parentChainCode:
          showWholeGroup && selectedParentChainFilter !== 'all'
            ? selectedParentChainFilter
            : null,
        toDate: provideEndDate(toDate),
        fromDate,
        pageSize,
        pageIndex,
        kind
      })
      .then(data => {
        setStats({
          bookingsTotal: data.bookingsTotal,
          bookingsTotalRate: data.bookingsTotalRate,
          deliveriesTotal: data.deliveriesTotal,
          deliveriesSent: data.deliveriesSent,
          clicksTotal: data.clicksTotal,
          hasEmailComponent: data.hasEmailComponent ?? true,
          campaignMedium: data.campaignMedium,
          deliveriesSentText: data.deliveriesSentText,
          deliveriesSentEmail: data.deliveriesSentEmail,
          clicksText: data.clicksText,
          clicksEmail: data.clicksEmail,
          bookingsText: data.bookingsText,
          bookingsEmail: data.bookingsEmail
        })

        setBookings(data.bookingViews?.items)
        setTotalSize(data.bookingViews?.count)
        setIsErred(false)
      })
      .catch(() => {
        setIsErred(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [
    fromDate,
    toDate,
    segment,
    kind,
    pageIndex,
    pageSize,
    showWholeGroup,
    parentChainCode,
    searchKey,
    selectedParentChainFilter
  ])

  const handleDownloadData = async () => {
    setDownloadCSVLoading(true)
    const data = await performanceReportsApi.downloadConversionsBreakdownReport({
      campaign: segment,
      onlyDirectBooking: searchKey,
      parentChainCode:
        showWholeGroup && selectedParentChainFilter !== 'all'
          ? selectedParentChainFilter
          : null,
      toDate: provideEndDate(toDate),
      fromDate,
      kind
    })

    let fileName = category
      ? `guests_booked_after_${category}_months.csv`
      : 'guests_booked.csv'

    if (data) {
      download(data, fileName)
    }
    setDownloadCSVLoading(false)
  }

  const { postEvent, plausibleEvents } = usePlausible()

  useFirstRender(() => {
    postEvent(plausibleEvents.ViewRegainedLostGuestSegment, {
      category
    })
  }, [postEvent, plausibleEvents, category])

  if (activeSubscriberId) {
    return (
      <BookingHistory
        subscriberId={activeSubscriberId}
        onClose={() => setActiveSubscriberId(null)}
      />
    )
  }

  if (activeBookingId) {
    return (
      <BookingDetailsDialog
        bookingId={activeBookingId}
        onClose={() => setActiveBookingId(null)}
      />
    )
  }

  return (
    <BookingListDialog
      title={category}
      currentSubsidiaryId={currentSubsidiaryId}
      onClose={onClose}
      isLoading={isLoading}
      isErred={isErred}
      category={category}
      stats={stats}
      bookings={bookings}
      setActiveSubscriberId={setActiveSubscriberId}
      setActiveBookingId={setActiveBookingId}
      version="ConversionsBySegments"
      downloadCsv={handleDownloadData}
      downloadCSVLoading={downloadCSVLoading}
      isPaginated={{
        pageIndex,
        pageSize,
        setPageIndex,
        totalSize
      }}
    />
  )
}

export default CampaignConversionResults
